import { BUSINESSES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import businessesTypes from '../../constants/businessesTypes'
import { axios } from '../../services'

const update_business_request = () => {
  return {
    type: businessesTypes.update.request
  }
}

const update_business_success = (response) => {
  return {
    type: businessesTypes.update.success,
    payload: response.data.business
  }
}

const update_business_failure = (messages) => {
  return {
    type: businessesTypes.update.failure,
    payload: messages
  }
}

const update_business = (business_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_business_request())

    // Request
    axios.patch(
      formatRoute(BUSINESSES_ROUTES.update, {id: business_id}),
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "Business data has been updated")
      dispatch( update_business_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating business."]
      }
      window.showSnackbar('error', errors)
      dispatch( update_business_failure(errors))
    })
  }

}

export {
  update_business
}



// WEBPACK FOOTER //
// ./src/js/actions/businesses/update.js